import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top on every pathname change.
 * Mount inside a <BrowserRouter> once.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use rAF so the new route has begun painting before we yank scroll
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    });
  }, [pathname]);
  return null;
};
